// Vue Dependencies
import Vue from "vue";
import Vuex from "vuex";
import VueSweetalert2 from "vue-sweetalert2";
//import { getField, updateField } from 'vuex-map-fields';
// Modules
// Welcome Drip
import welcomeDrip from "./modules/welcome_drip";
// Recurring Drip
import recurringDrip from "./modules/recurring_drip";
import schedules from "./modules/schedules";
// Domain
import domain from "./modules/domain";
// Segment
import segment from "./modules/segments";
// Callout
import audience from "./modules/audience";
//import createPersistedState from "vuex-persistedstate";
import push from "./modules/push";
// import connections from "./modules/connections";
import triggers from "./modules/triggered_notifications";
import tags from "./modules/tags";
import user from "./modules/user";
// import admin from "./modules/admin";

// Dev Settings
import clients from "../store/modules/clients_management/clients";
import roles from "../store/modules/clients_management/roles";
import permissions from "../store/modules/clients_management/permissions";
import users from "../store/modules/clients_management/users";
import clusters from "../store/modules/clients_management/clusters";
import dbsubs from "../store/modules/clients_management/dbsubs";

Vue.use(Vuex, VueSweetalert2);

//Export Modules
export default new Vuex.Store({
  //plugins: [createPersistedState()],
  modules: {
    welcomeDrip,
    schedules,
    recurringDrip,
    domain,
    segment,
    audience,
    push,
    // connections,
    triggers,
    tags,
    user,
    // admin,
    clients,
    clusters,
    users,
    roles,
    permissions,
    dbsubs,
  },
});
